var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8686 0.195603H1.27733C1.02483 0.195603 0.81865 0.401781 0.81865 0.654281V11.3811C0.81865 11.6336 1.02483 11.8398 1.27733 11.8398H21.8686C22.1211 11.8398 22.3273 11.6336 22.3273 11.3811V0.654281C22.3273 0.403281 22.1235 0.198052 21.8731 0.195624V0.195603H21.8686ZM21.4144 10.9225H1.7405V1.11296H21.4144V10.9225Z",
    fill: "#187C85",
    stroke: "#187C85",
    strokeWidth: 0.198638
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5725 9.42945C13.1544 9.42945 14.427 7.89256 14.427 6.0225C14.427 4.15244 13.1544 2.61556 11.5725 2.61556C9.99061 2.61556 8.7181 4.15244 8.7181 6.0225C8.7181 7.89256 9.99061 9.42945 11.5725 9.42945ZM11.5725 3.43714C12.6789 3.43714 13.6009 4.58351 13.6009 6.0225C13.6009 7.4615 12.6789 8.60786 11.5725 8.60786C10.4661 8.60786 9.54417 7.4615 9.54417 6.0225C9.54417 4.58351 10.4661 3.43714 11.5725 3.43714Z",
    fill: "#187C85",
    stroke: "#187C85",
    strokeWidth: 0.102866
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64451 8.02805C4.19108 8.02805 4.63522 8.47218 4.63522 9.01875C4.63522 9.2448 4.81996 9.42954 5.04601 9.42954H7.48516C7.71121 9.42954 7.89595 9.2448 7.89595 9.01875C7.89595 8.7927 7.71121 8.60796 7.48516 8.60796H5.41067C5.25337 7.9382 4.72507 7.40989 4.05531 7.25259V4.78811C4.72507 4.63082 5.25337 4.10251 5.41067 3.43275H7.48516C7.71121 3.43275 7.89595 3.24801 7.89595 3.02196C7.89595 2.7959 7.71121 2.61116 7.48516 2.61116H5.04601C4.81996 2.61116 4.63522 2.7959 4.63522 3.02196C4.63522 3.56852 4.19108 4.01266 3.64451 4.01266C3.41846 4.01266 3.23372 4.1974 3.23372 4.42345V7.61725C3.23372 7.84331 3.41846 8.02805 3.64451 8.02805Z",
    fill: "#187C85",
    stroke: "#187C85",
    strokeWidth: 0.102866
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7385 8.60357H15.664C15.438 8.60357 15.2533 8.7883 15.2533 9.01436C15.2533 9.24041 15.438 9.42515 15.664 9.42515H18.1032C18.3292 9.42515 18.514 9.24041 18.514 9.01436C18.514 8.46779 18.9581 8.02365 19.5047 8.02365C19.7307 8.02365 19.9155 7.83891 19.9155 7.61286V4.41906C19.9155 4.19301 19.7307 4.00827 19.5047 4.00827C18.9581 4.00827 18.514 3.56413 18.514 3.01756C18.514 2.79151 18.3292 2.60677 18.1032 2.60677H15.664C15.438 2.60677 15.2533 2.79151 15.2533 3.01756C15.2533 3.24362 15.438 3.42835 15.664 3.42835H17.7385C17.8958 4.09811 18.4241 4.62642 19.0939 4.78372V7.2482C18.4241 7.4055 17.8958 7.93381 17.7385 8.60357Z",
    fill: "#187C85",
    stroke: "#187C85",
    strokeWidth: 0.102866
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumsIcon);
export default __webpack_public_path__ + "static/media/premiums-icon.5af62fdc68daf10ed108a43379bbc302.svg";
export { ForwardRef as ReactComponent };